module.exports = __webpack_public_path__ + "c_static/img/3-3电脑京东收藏夹.8d0a097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/3-3电脑京东收藏夹.jpg
// module id = jBoa
// module chunks = 33